import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const Highcharts = window.Highcharts;
const HighchartsReact = window.HighchartsReact;

const COLUMN_COLOR_PALETTE = ["#ca3d3c", "#54925b", "#b9d263", "#f4b446", "#3282b9", "#4fbded", "#cc4c96", "#89357a", "#bb6d49", "#8d4e47", "#7f8982", "#3f5553"];

const TOOLTIP_TOP_BORDER = "#055ea0";

const tooltipOptions = {
  animation: true,
  backgroundColor: "transparent",
  borderWidth: 0,
  headerFormat: `<div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
         <div style="background-color: white; padding: 10px; border-top: 8px solid ${TOOLTIP_TOP_BORDER}">
         <b>{point.key}</b></br></div>`,
  pointFormat: `<div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
           <div style="color: {series.color}; font-weight: bold">
             {series.name} - £{point.y} million</b></b>
           </div>
         </div>`,
  footerFormat: "</div>",
  hideDelay: 100,
  shadow: false,
  shape: "square",
  shared: true,
  style: { color: "black", padding: 0 },
  useHTML: true,
};

const formatNumber = val => parseFloat(val.toFixed(2));

const sectorOptions = [
  { value: "all_applications", label: "All applications" },
  { value: "water_total", label: "Water" },
  { value: "water_networks", label: " - Water Networks" },
  { value: "water_resources", label: " - Water Resources" },
  { value: "water_treatment", label: " - Water Treatment" },
  { value: "wastewater_total", label: "Wastewater" },
  { value: "wastewater_networks", label: " - Wastewater Networks" },
  { value: "wastewater_treatment", label: " - Wastewater Treatment" },
  { value: "sludge", label: " - Sludge" },
];

class UKChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSector: "all_applications",
      chartOptions: {
        chart: {
          type: "column",
          height: 600,
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false
        },
        legend: {
          itemMarginBottom: 14,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 0,
        },
        colors: COLUMN_COLOR_PALETTE,
        title: {
          text: "TOTEX - all applications",
          style: {
            fontWeight: "bold",
            fontSize: "1.5rem"
          }
        },
        series: this.initialiseData(),
        tooltip: tooltipOptions,
        xAxis: {
          categories: ["2025-2026", "2026-2027", "2027-2028", "2028-2029", "2029-2030"],
          crosshair: true,
          tickLength: 0
        },
        yAxis: {
          min: 0,
          title: {
            text: "£million"
          },
        },
      }
    };
  }

  sumValues = (arrs) => arrs.reduce((r, nested) => {
    if(nested.length > 0) {
      return nested.map((val, i) => ((r[i]) || 0) + val);
    }
    // some utilities don't have wastewater values - populate an array of 0s to sum their all_applications totals
    return Array(5).fill(0).map((val, i) => ((r[i]) || 0) + val);
  }, []);

  initialiseData = () => {
    const { uk_totex_chart } = this.props.data;
    const data = uk_totex_chart.map(d => ({name: d.utility_name_sorting, data: d.all_applications = this.sumValues([d.water_networks, d.water_resources, d.water_treatment, d.sludge, d.wastewater_networks, d.wastewater_treatment])}));
    return data.map(d => ({ name: d.name, data: d.data.map(val => formatNumber(val)) }));
  }

  onChangeSector = (e) => {
    const { uk_totex_chart } = this.props.data;
    let data = [];

    if (e === "water_total") {
      data = uk_totex_chart.map(d => ({ name: d.utility_name_sorting, e: d[e] = this.sumValues([d.water_networks, d.water_resources, d.water_treatment]) }));
    }
    if (e === "wastewater_total") {
      data = uk_totex_chart.map(d => ({ name: d.utility_name_sorting, e: d[e] = this.sumValues([d.sludge, d.wastewater_networks, d.wastewater_treatment]) }));
    }

    data = uk_totex_chart.map(d => ({ name: d.utility_name_sorting, data: d[e].map(val => formatNumber(val)) }));
    const renderChartTitle = str => str.toLowerCase().split("_").map(x => `${x.charAt(0).toUpperCase() + x.substr(1).toLowerCase()}`).join(" ");

    this.setState({
      selectedSector: e,
      chartOptions: {
        series: data,
        title: {
          text: `TOTEX - ${renderChartTitle(e)}`,
        }
      },
    });
  }

  render() {
    const { selectedSector, chartOptions } = this.state;

    return (
      <div>
        <div id="uk-totex-chart-select-wrapper">
          <Select
            classNamePrefix="Select"
            classNames={{ container: () => "Select__container" }}
            onChange={e => this.onChangeSector(e.value)}
            options={sectorOptions}
            placeholder="Select sector"
            isSearchable={false}
            value={sectorOptions.find(o => o.value === selectedSector) || null}
            className="uk-totex-chart-select"
          />
        </div>
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={"chart"}
          options={chartOptions}
        />
      </div>
    );
  }
}

UKChart.propTypes = {
  data: PropTypes.shape({
    uk_totex_chart: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }),
};

export default UKChart;
